import { useEffect, useState } from 'react';

const DURATION_MS = 10 * 60 * 1000;
const STORAGE_KEY = 'mf-offer-timer-end';

function readDeadline(): number {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = Number(raw);
      if (Number.isFinite(parsed)) return parsed;
    }
    const deadline = Date.now() + DURATION_MS;
    sessionStorage.setItem(STORAGE_KEY, String(deadline));
    return deadline;
  } catch {
    return Date.now() + DURATION_MS;
  }
}

export function useOfferTimer() {
  const [remainingMs, setRemainingMs] = useState(() => Math.max(0, readDeadline() - Date.now()));

  useEffect(() => {
    const deadline = readDeadline();
    const tick = () => setRemainingMs(Math.max(0, deadline - Date.now()));
    tick();
    const id = window.setInterval(tick, 250);
    return () => window.clearInterval(id);
  }, []);

  const totalSec = Math.floor(remainingMs / 1000);
  const minutes = Math.floor(totalSec / 60);
  const seconds = totalSec % 60;

  return {
    minutes,
    seconds,
    expired: remainingMs <= 0,
  };
}
